__webpack_require__.p = "https://assets.cannisters.cafe/461a50b1c96c7bc856ea02065ad21ad17ed519ec/";